import { useState, useLayoutEffect, useRef } from 'react';

/**
 * Mede a altura (offsetHeight) do elemento referenciado e a mantém atualizada
 * via ResizeObserver. O elemento precisa estar montado no primeiro render —
 * ref atribuída condicionalmente não é observada.
 *
 * @param {number} [fallback=56] Altura usada até a primeira medição.
 * @returns {[React.RefObject, number]} [ref, altura em px]
 */

export default function useElementHeight(fallback = 56) {
    const elementRef = useRef(null);
    const [height, setHeight] = useState(fallback);

    useLayoutEffect(() => {
        if (!elementRef.current) return;

        const updateHeight = () => setHeight(elementRef.current.offsetHeight);
        updateHeight();

        const observer = new ResizeObserver(updateHeight);
        observer.observe(elementRef.current);

        return () => observer.disconnect();
    }, []);

    return [elementRef, height];
}
